import * as React from "react"
import { Consumer } from "./Context"

export class Draggable extends React.Component {
    // static propTypes = {
    //     children: PropTypes.func.isRequired,
    //     payload: PropTypes.object.isRequired,
    // };
    onDragStart = event => {
        if (!this.props.context.isActive) {
            return
        }
        console.log("start", event.target)

        // https://stackoverflow.com/questions/7680285/how-do-you-turn-off-setdragimage?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
        var img = document.createElement("img")
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        event.dataTransfer.setDragImage(img, 0, 0)
        this.props.context.startDrag(this, this.props.payload)
        event.stopPropagation()
        this.props.onDragStart && this.props.onDragStart()
    }
    onDragEnd = event => {
        if (!this.props.context.isActive) {
            return
        }
        console.log("end", event.target)

        this.props.context.stopDrag(this, this.props.payload)
        this.props.onDragEnd && this.props.onDragEnd()
    }
    getPropsAndState = () => {
        return {
            getRootProps: ({ className } = {}) => ({
                className: this.props.context.isDragging(this)
                    ? "isDraggingElm " + className
                    : className,
                draggable: this.props.context.isActive,
                onDragStart: this.onDragStart,
                onDragEnd: this.onDragEnd,
            }),
            dnd: {
                isDragging: this.props.context.isDragging(this),
            },
        }
    }
    render() {
        return this.props.children(this.getPropsAndState())
    }
}

export default function DraggableWithContext(props) {
    return <Consumer>{context => <Draggable context={context} {...props} />}</Consumer>
}



// WEBPACK FOOTER //
// ./src/features/editor/dnd/Draggable.js